import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import LoginEx from '@/components/LoginEx'
import Subscription from '@/components/Subscription'
import Contact from '@/components/Contact'
import Profile from '@/components/Profile'
import Privacy from '@/components/Privacy'
import TaC from '@/components/TaC'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/loginEx',
      name: 'LoginEx',
      component: LoginEx
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/subscription',
      name: 'Subscription',
      component: Subscription
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/tac',
      name: 'TaC',
      component: TaC
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js